/* global $:false */

export default class Anniversary {
  static init () {
    Array.from($('.js-anniversary-popup')).map((el) =>
      new Anniversary(el))
  }

  constructor (el) {
    this.closePopup = this.closePopup.bind(this)
    this.el = $(el)
    this.findElements()
    this.readDataAttributes()
    this.setupBindings()
    if (this.el.hasClass('qa-skip-anniversary-popup')) { this.closePopup() }
  }

  findElements () {
    this.closeButton = this.el.find('.js-anniversary-popup__close')
  }

  readDataAttributes () {
    this.url = this.el.data('url')
  }

  setupBindings () {
    this.closeButton.click(event => {
      event.preventDefault()
      this.closePopup()
    })
  }

  closePopup () {
    $.ajax({
      url: this.url,
      data: { _method: 'delete' },
      type: 'post',
      success: data => {
        this.el.hide()
      }
    })
  }
}
